<template lang="pug">
	div
		#sfc-main-container.sfc-container-redesign-v1(v-bind:class="{'userIsLoggedIn' : userSubscribed()}")
			sfc-sentry
			sfc-hello-bar-v3(v-if="showBar")
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu(v-if="!blankLayout")
			sfc-menu-mobile(v-if="!blankLayout")
			sfc-onboarding-modal-v2
			sfc-header(v-if="!blankLayout")
			sfc-login
			sfc-forgot-password
			main#sfc-main-content(role="main" :class="{'no-margin-top': !userSubscribed(), 'sfc-blank-layout': blankLayout, 'new-font': isComparePlans}")
				nuxt
			no-ssr(v-if="!$store.state.userIsLoggedIn && !blankLayout")
				b-row#bottom-ad
					.col-md-12.col-sm-12.col-xs-12.ad-align-center
						.bottom-banner(style="")
							sfc-dfp-ad(:ad-unit="bottomBannerAdUnit" sizes="[[600,230], [728,90]]")
			sfc-footer(v-if="!blankLayout")
			no-ssr
				sfc-gdpr-banner
			no-ssr
				sfc-modal-trigger
			no-ssr
				enroll-now-modal
		no-ssr
			sfc-college-savings-questions-modal
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
	.sfc-blank-layout
		>>> .sfc-container
			width: 100%
	>>> .top-sponsor-container
		&.collapsed
			min-height: 0px
			height: 0px

	>>> .top-sponsor-container-mobile
		&.collapsed
			min-height: 0px
			height: 0px

	#bottom-ad
		background: bg-dark-gray
		.bottom-banner
			padding: 15px 0

	#sfc-main-content
		padding-bottom 45px
		&.student-loan-calculator-content
			padding-bottom 0

	>>>#sfc-main-content
		&.new-font
			*
				font-family: "IBM Plex Sans", sans-serif !important

	#bottom-ad
		background: #f8f8f8
		border: none !important
		.bottom-banner
			text-align: center
			padding: 24px 0
			@media (max-width: 767px)
				padding: 16px 0
</style>

<script>
import SfcHeader from '@/layouts/common/redesign-v1/sfc-header'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcModalTrigger from '@/common/components/modals/modal-trigger'
import EnrollNowModal from '@/common/components/modals/enroll-now-modal'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		SfcModalTrigger,
		sfcCollegeSavingsQuestionsModal,
		EnrollNowModal,
		SfcHelloBarV3,
		SfcEnrollNowUrgencyWidget,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2
	},
	data: function() {
		let blankLayout = false
		if(this.$route.query.layout && this.$route.query.layout == "blank"){
			blankLayout = true
		}
		let bottomBannerAdUnit = (this.$route.path.indexOf('/pro-dashboard')>=0) ? 'savingforcollege_prodashboard_bottom_leaderboard' : 'savingforcollege_other_bottom_leaderboard'

		let isComparePlans = (this.$route.path.indexOf('/compare-plans')>=0) ? true : false
		return {
			bottomBannerAdUnit,
			blankLayout,
			isComparePlans
		}
	},
	computed: {
		showBar(){
			return (this.$route.path.indexOf('/5-cap-ratings') != -1 || this.$route.path.indexOf('/tools-calculators') != -1 || this.$route.path.indexOf('/enroll-in-a-529-plan') != -1 || this.$route.path.indexOf('/529-plans/performance-rankings') != -1 || this.$route.path.indexOf('/529-plan-investment-options') != -1 || this.$route.path.indexOf('/529-plan-details') != -1) || this.$route.path.indexOf('/tutorial101') != -1 || this.$route.path.indexOf('/529-plans') != -1 || this.$route.path.indexOf('/community') != -1
		}
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
